"use client";

import React from "react";
import Link from "@/components/link";
import { usePathname } from "next/navigation";

import { cn } from "@/lib/utils";

function Navbar() {
  const pathname = usePathname();
  const isHomepage = pathname === "/";

  if (!isHomepage) return null;

  return (
    <ul
      className={cn(
        "hidden md:flex items-center gap-x-6 text-sm",
        "[&_a]:text-primary [&_a]:inline-flex [&_a]:items-center",
        "[&_a]:leading-none [&_a]:gap-x-3 [&_a]:font-semibold"
      )}
      data-testid="nav-links"
    >
      <li data-testid="nav-item-online-courses">
        <Link href="/goal" target="_blank" data-testid="store-link">
          Online Courses
        </Link>
      </li>
      <li data-testid="nav-item-offline-courses">
        <Link href="/offline-courses" data-testid="offline-courses-link">
          Offline Courses
        </Link>
      </li>
    </ul>
  );
}

export default Navbar;
